import forceIndex from "./forceIndex";
import ema from "./ema";
import { zipper } from "../utils";
import { SmoothedForceIndex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  const underlyingAlgorithm = forceIndex();
  const merge = zipper().combine((force, m1, m2) => {
    return { force, m1, m2 };
  });

  let options = defaultOptions;
  function calculator(data) {
    const { m1Period, m2Period } = options;
    const { sourcePath, volumePath } = options;

    const algo = underlyingAlgorithm.options({ sourcePath, volumePath });

    const force = algo(data);

    const ema1 = ema().options({ windowSize: m1Period, sourcePath: undefined });
    const ema2 = ema().options({ windowSize: m2Period, sourcePath: undefined });

    const m1Result = ema1(force);
    const m2Result = ema2(force);

    return merge(force, m1Result, m2Result);
  }

  calculator.undefinedLength = function () {
    const { m2Period } = options;
    return underlyingAlgorithm.undefinedLength() + m2Period - 1;
  };
  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
